import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=5a19cb31&scoped=true&"
import script from "./Header.js?vue&type=script&lang=js&"
export * from "./Header.js?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=5a19cb31&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a19cb31",
  null
  
)

export default component.exports